function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#174ABC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.85759 21.4997H6.74777V11.4852H9.85759V21.4997ZM8.301 10.1191C7.30658 10.1191 6.5 9.29542 6.5 8.301C6.5 7.82335 6.68975 7.36526 7.0275 7.0275C7.36526 6.68975 7.82335 6.5 8.301 6.5C8.77866 6.5 9.23675 6.68975 9.57451 7.0275C9.91226 7.36526 10.102 7.82335 10.102 8.301C10.102 9.29542 9.29509 10.1191 8.301 10.1191ZM21.4967 21.4997H18.3935V16.6247C18.3935 15.4628 18.3701 13.9729 16.7767 13.9729C15.1598 13.9729 14.9121 15.2352 14.9121 16.541V21.4997H11.8056V11.4852H14.7882V12.8512H14.8317C15.2469 12.0644 16.261 11.234 17.7741 11.234C20.9214 11.234 21.5 13.3066 21.5 15.9986V21.4997H21.4967Z",
  fill: "white"
});

function SvgFooterIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon5);
export default __webpack_public_path__ + "static/media/footer_icon5.e6b68720.svg";
export { ForwardRef as ReactComponent };